import React from 'react';
import PropTypes from 'prop-types';
import { get, isNull } from 'lodash';
import classNames from 'classnames';

const MAX_WIDTH = 800;
const MAX_HEIGHT = 600;
const QUALITY = 0.75;

const resizeImage = (image) => {
  let canvas = document.createElement('canvas');
  let width = image.width;
  let height = image.height;
  if (width > height) {
    if (width > MAX_WIDTH) {
      height = Math.round(height * MAX_WIDTH / width);
      width = MAX_WIDTH;
    }
  } else {
    if (height > MAX_HEIGHT) {
      width = Math.round(width * MAX_HEIGHT / height);
      height = MAX_HEIGHT;
    }
  }
  canvas.width = width;
  canvas.height = height;
  let ctx = canvas.getContext('2d');
  ctx.drawImage(image, 0, 0, width, height);
  return canvas.toDataURL('image/jpeg', QUALITY);
}

export default class ASQImage extends React.PureComponent {
  static propTypes = {
    asq: PropTypes.object.isRequired,
    responseType: PropTypes.object.isRequired,
    answer: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = { isUploading: false };
  }

  componentDidUpdate(prevProps) {
    if (get(prevProps.answer, 'imageUrl') !== get(this.props.answer, 'imageUrl')) {
      this.setState({ isUploading: false });
    }
  }

  triggerFileUpload = () => {
    this.inputElement.click();
  }

  onImageUpload = e => {
    let file = e.target.files[0];
    if (!file || !file.type.match(/image.*/) || this.state.isUploading) return;

    this.setState( {isUploading: true });
    let reader = new FileReader();
    const { onChange, answer, responseType } = this.props;
    reader.addEventListener('load', () => {
      let image = new Image();
      image.src = reader.result;
      image.onload = () => {
        let resizedDataUrl = resizeImage(image);
        onChange(get(answer, 'id', null), {
          asqResponseTypeId: responseType.id,
          image: resizedDataUrl }
        );
      };
    }, false);
    reader.readAsDataURL(file);
  }

  removeImage = () => {
    const answerId = get(this.props.answer, 'id', null);
    this.props.onDelete(answerId, {
      asqResponseTypeId: this.props.responseType.id,
      id: answerId }
    );
  }

  render() {
    const { responseType, answer } = this.props;
    const clsUpload = classNames('o-sp-button o-sp-button--back', { 'u-disabled': this.state.isUploading });
    return (
      <div className='o-image-answer u-flex u-padding-bottom--base'>
        { (isNull(answer) || isNull(answer.imageUrl)) ?
          <div>
            <a className={clsUpload} onClick={this.triggerFileUpload}>
              { this.state.isUploading ?
                <span>
                  <i className='o-spinner-dual'></i>&nbsp;&nbsp;Uploading...
                </span> :
                <span>
                  <i className='sp-icon-camera'></i>&nbsp;&nbsp;{responseType.label || 'Upload Photo'}
                </span> }
            </a>
            <input type='file'
              ref={input => this.inputElement = input}
              accept='image/*'
              onChange={this.onImageUpload}
              multiple={false} />
          </div> :
          <div className='o-image-answer__preview callout'>
            <img className='u-margin-right--large' alt='Uploaded Answer' src={answer.imageUrl}/>
            <button className='close-button cs-txt--sp-blue' aria-label='Remove Image' type='button' onClick={this.removeImage}>
              <span aria-hidden='true'>&times;</span>
            </button>
          </div> }
      </div>
    );
  }
}
